import React from 'react';

import { SingleSelect, SingleSelectProps } from 'components/SingleSelect/SingleSelect';

import { languages } from './languages';

export const GooderaLanguagePicker = (props: Omit<SingleSelectProps, 'options'>) => {
  const options = Object.keys(languages).map((languageName) => ({
    id: languages[languageName as keyof typeof languages],
    name: languageName,
  }));
  return <SingleSelect {...props} disableClearable options={options} />;
};
